<template>
    <div />
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import axios from "axios";
    import { appSettings } from "../mixins/app-settings";

    export default {
        name: "Landing",
        mixins: [appSettings],
        computed: {
            ...mapState({
                apiBaseUrl: state => state.session.apiBaseUrl
            })
        },
        methods: {
            ...mapMutations([
                "setSessionIds",
                "setSpriteImagesReady",
                "setLoadingStatus"
            ])
        },
        mounted() {
            // Preload the sprite image. Mark is ready to display via Vuex.
            let spriteImg = new Image();
            spriteImg.onload = () => { this.setSpriteImagesReady(true); }
            spriteImg.src = require(window.devicePixelRatio < 1.5 ? "@/assets/images/sprites.png" : "@/assets/images/sprites-2x.png");

            if (this.$route.query.at) {
                axios.defaults.headers.common['Authorization'] = "Token " + encodeURI(this.$route.query.at.replace("Token", "").trim());
            }

            // Save query string parameters in application's store.
            this.setSessionIds({
                siteId: this.$route.query.s,
                checkId: this.$route.query.c,
                accessToken: this.$route.query.at,
                accountId: this.$route.query.a,
                siteNumber: this.$route.query.sn,
                checkNumber: this.$route.query.cn,
                businessDate: this.$route.query.b,
                checkOpenDateTime: this.$route.query.cod,
                checkTotal: this.$route.query.t,
                paymentId: this.$route.query.pid,
                paymentMethod: this.$route.query.pm
            });

            // Go to links page if prompt = 1.
            if (this.$route.query.prompt !== undefined && this.$route.query.prompt == 1) {
                this.$router.push({ name: "Links" });
                return;
            }

            // Test to see if we have all the required parameters. Always respect those if they are present. Note that we
            // could be here due to a fresh QR code scan, user hitting the back button on the main page, or user hitting
            // refresh button on the main page and the code triggers a back navigation.
            if (this.$route.query.s !== undefined && this.$route.query.c !== undefined && this.$route.query.a !== undefined && this.$route.query.at !== undefined) {

                // A redirect url from server with the intension of displaying an error page
                // would normally have an error code query string parameter. Error page with specific
                // error code can't be accessed directly from the browser's address bar. Thus, the app needs
                // to validate the url and redirect to error page.
                if (this.$route.query.ec !== undefined) {

                    const requestUrl = this.getApiBaseUrl() + "/check/existsinsession/" + this.$route.query.s + "/" + this.$route.query.c;
                    const errorCode = this.$route.query.ec;

                    axios.post(requestUrl)
                        .then(response => {
                            this.setLoadingStatus(false);
                            if (response.data)
                                this.$router.push({ name: "Error", params: { errorCode: errorCode } });
                            else
                                this.$router.push({ name: "Error", params: { errorCode: "1001" } });
                        })
                        .catch(error => {
                            console.error(error);
                        });
                }
                else {
                    // Redirect to the NsPay page without the parameters.
                    this.$router.push({ name: "NsPay" });
                }

                return;
            }

            // Display an error message if any of the require parameters is missing.
            this.$router.push({ name: "Error", params: { errorCode: "1001" } });
        }
    }
</script>